import { render, staticRenderFns } from "./CornerRibbon.vue?vue&type=template&id=21972228&scoped=true"
import script from "./CornerRibbon.vue?vue&type=script&lang=js"
export * from "./CornerRibbon.vue?vue&type=script&lang=js"
import style0 from "./CornerRibbon.vue?vue&type=style&index=0&id=21972228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21972228",
  null
  
)

export default component.exports